import { useRef } from 'react'

import FilterBox from '@/organisms/FilterBox'

import Bar from './includes/Bar'
import Content from './includes/Content'
import { PresentationProps } from './ts'

function Presentation(props: PresentationProps) {
  const { maxPrice, totalItems, noResults, filters, title, withoutSort } = props

  const sectionElement = useRef<HTMLElement>(null)
  const scrollViewOffsetTop = sectionElement?.current?.offsetTop || 0

  return (
    <div className="flex flex-col items-start xl:space-x-20 xl:flex-row box">
      {filters && (
        <FilterBox
          withoutSort={withoutSort}
          count={totalItems ?? 0}
          filters={filters}
          maxPrice={maxPrice}
        />
      )}
      <section
        ref={sectionElement}
        role="complementary"
        className="relative flex flex-col w-full"
      >
        {filters && <Bar count={totalItems} filters={filters} title={title} />}
        <Content
          isVisible={props.shouldDisplayContent}
          topPosition={scrollViewOffsetTop}
          noResults={noResults}
          totalItems={totalItems}
        >
          {props.children}
        </Content>
      </section>
    </div>
  )
}

export default Presentation
